<template src="./index.html"></template>

<script>
import { getTreeListNew, updatePermissionsToRole } from '../../../../../../api/home.js';
import { getdata } from './data.js';
export default {
	props: {
		id: {
			type: String,
			default: ''
		},
		activeName: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			data: [],
			defaultProps: {
				children: 'children',
				label: 'resName'
			}
		};
	},
	watch: {
		id: function(indexVal, oldVal) {
			this.searrchForData();
		},
		activeName: function(indexVal, oldVal) {
			if (indexVal == '2') {
				this.searrchForData();
			}
		}
	},
	created() {
		this.searrchForData();
	},
	mounted() {},
	methods: {
		rousesubject() {
			let ids = this.$refs.tree.getCheckedKeys();
			var functionIds = [];
			ids.forEach(v => {
				wholeid(this.data, v);
			});
			function wholeid(data, id) {
				data.forEach(v => {
					if (v.children != null) {
						v.children.forEach(cv => {
							if (cv.children != null) {
								cv.children.forEach(ccv => {
									if (ccv.children != null) {
										ccv.children.forEach(cccv => {
											if (cccv.id == id) {
												functionIds.push(v.id);
												functionIds.push(cv.id);
												functionIds.push(ccv.id);
												functionIds.push(cccv.id);
											}
										});
									} else {
										if (ccv.id == id) {
											functionIds.push(v.id);
											functionIds.push(cv.id);
											functionIds.push(ccv.id);
										}
									}
								});
							} else {
								if (cv.id == id) {
									functionIds.push(v.id);
									functionIds.push(cv.id);
								}
							}
						});
					} else {
						if (v.id == id) {
							functionIds.push(v.id);
						}
					}
				});
			}
			for (var i = 0; i < functionIds.length; i++) {
				for (var j = i + 1; j < functionIds.length; j++) {
					if (functionIds[i] == functionIds[j]) {
						this.$delete(functionIds, j);
						j--;
					}
				}
			}
			let params = { roleId: this.id, functionIds: functionIds.join(',') };
			updatePermissionsToRole(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('保存成功');
					this.searrchForData();
				} else {
					this.$message.success(res.data.success);
				}
			});
		},
		searrchForData() {
			if (this.activeName == '2') {
				let params = { roleId: this.id };
				getTreeListNew(params).then(res => {
					if (res.data.code == '200') {
						this.data = res.data.data;
						let chuncu = [];
						yixuan(this.data);
						this.$refs.tree.setCheckedKeys(chuncu);
						function yixuan(data) {
							for (var i = 0; i < data.length; i++) {
								if (data[i].children != null) {
									yixuan(data[i].children);
								} else {
									if (data[i].checked) {
										chuncu.push(data[i].id);
									}
								}
							}
						}
					}
				});
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
